import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommitteesResponseDto, CommitteeBoardMemberDto, CommitteesUpsertRequest } from '../../models/api/companyCommitteesDto';
import { YearlyResource } from '../../models/api/yearlyResource';

export interface CommitteeContext {
  boardType?: number;
  /** Board members for the requested year — populated regardless of envelope state. */
  boardMembers: CommitteeBoardMemberDto[];
}

@Injectable({
  providedIn: 'root'
})
export class CompanyCommitteesService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  getAll(companyId: string, year?: number): Observable<YearlyResource<CommitteesResponseDto, CommitteeContext>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<CommitteesResponseDto, CommitteeContext>>(
      `${this.apiUrl}/${companyId}/committees`,
      { params }
    );
  }

  getById(companyId: string, boardMemberId: string, year?: number): Observable<CommitteeBoardMemberDto> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<CommitteeBoardMemberDto>(`${this.apiUrl}/${companyId}/committees/${boardMemberId}`, { params });
  }

  upsert(companyId: string, request: CommitteesUpsertRequest): Observable<YearlyResource<CommitteesResponseDto, CommitteeContext>> {
    return this.http.put<YearlyResource<CommitteesResponseDto, CommitteeContext>>(`${this.apiUrl}/${companyId}/committees`, request);
  }
}
